import React from "react";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { WizardFormProps } from "../../../../../../types/Forms";
import { AgreeTerms, ContactNumber, Email, FirstName, LastName, State, ZipCode } from "../../../../../../constants";

const YourInfoForm: React.FC<WizardFormProps> = ({ formData, updateFormData, register, errors }) => {
  return (
    <Form className="needs-validation custom-input" noValidate>
      <Row className="g-3">
        <Col xxl="4" sm="6">
          <Label>{FirstName}<span className="txt-danger">*</span></Label>
          <Input {...register("firstName", { required: "First name is required" })} value={formData.firstName} type="text" placeholder="Enter first name" onChange={updateFormData} />
          {errors.firstName && <span className="text-danger">{errors.firstName.message}</span>}
        </Col>
        <Col xxl="4" sm="6">
          <Label>{LastName}<span className="txt-danger">*</span></Label>
          <Input {...register("lastName", { required: "Last name is required" })} type="text" placeholder="Enter last name" name="lastName" value={formData.lastName} onChange={updateFormData} />
          {errors.lastName && <span className="text-danger">{errors.lastName.message}</span>}
        </Col>
        <Col xxl="4" sm="6">
          <Label>{Email}<span className="txt-danger">*</span></Label>
          <Input {...register("email", { required: "Email is required" })} value={formData.email} type="email" placeholder="johan@example.com" onChange={updateFormData} />
          {errors.email && <span className="text-danger">{errors.email.message}</span>}
        </Col>
        <Col xxl="5" sm="6">
          <Label>{State}</Label>
          <Input {...register("state", { required: "State is required" })} value={formData.state} type="select" onChange={updateFormData} >
            <option value={""}>{"Choose..."}</option>
            <option value={"USA"}>{"USA "}</option>
            <option value={"U.K "}>{"U.K "}</option>
            <option value={"U.S"}>{"U.S"}</option>
          </Input>
          {errors.state && <span className="text-danger">{errors.state.message}</span>}
        </Col>
        <Col xxl="3" sm="6">
          <Label>{ZipCode}</Label>
          <Input {...register("zip", { required: "Zip is required" })} value={formData.zip} type="text" onChange={updateFormData} />
          {errors.zip && <span className="text-danger">{errors.zip.message}</span>}
        </Col>
        <Col xxl="4" sm="6">
          <Label>{ContactNumber}</Label>
          <Input {...register("contact", { required: "Conatct number is required" })} value={formData.contact} type="number" placeholder="Enter number" onChange={updateFormData} />
          {errors.contact && <span className="text-danger">{errors.contact.message}</span>}
        </Col>
        <Col xs="12">
          <FormGroup check>
            <Input id="invalidCheck-n" type="checkbox" required />
            <Label htmlFor="invalidCheck-n" check>{AgreeTerms}</Label>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};
export default YourInfoForm;
